import { deleteField, doc, updateDoc } from "firebase/firestore"

import { db } from "../../firebase"
import { PopupService } from "react-ui-components/components/PopupService"

export const options = ({ path, data, onSuccess }: any) => {
  return {
    filterType: "checkbox",
    onRowsDelete: async (rowsDeleted: { data: any[] }) => {
      const docRef = doc(db, typeof path === "string" ? path : path.split("/"))
      const keysToDelete = rowsDeleted.data
        .map((element: { dataIndex: string | number }) => data[element.dataIndex]?.key)
        .filter(Boolean)

      if (!keysToDelete.length) {
        return false
      }

      try {
        // A single updateDoc with all deleteField() sentinels commits atomically, so the
        // table refresh below can't race ahead of a delete that hasn't landed yet (the
        // previous per-row `forEach(async ...)` didn't await, so onSuccess's refetch often
        // ran before the writes committed and the "deleted" country reappeared).
        await updateDoc(
          docRef,
          Object.fromEntries(keysToDelete.map((key) => [key, deleteField()])),
        )
        onSuccess && onSuccess(data)
      } catch (error: any) {
        PopupService.pushPopup(`Failed to delete: ${error.message}`)
      }

      return false
    },
  }
}
